
























import { defineComponent, inject, reactive, ref, watch } from '@vue/composition-api'
import Editor from '@/components/Editor.vue'
import TextCheckbox from './components/TextCheckbox.vue'
import ImageCheckbox from './components/ImageCheckbox.vue'
import { EntityType } from '@/api/project/model'
import { sesstionPollItems } from '@/api/project/entity-type-option'
import TimeCustomSelect from '@/components/TimeCustomSelect.vue'
import { typeDurationOption } from '@/api/project/duration-option'
import _ from 'lodash'
import { useProjectStore } from '@/pinia/modules/project'
import { storeToRefs } from 'pinia'

export default defineComponent({
    components: {
        Editor,
        TextCheckbox,
        ImageCheckbox,
        TimeCustomSelect
    },
    setup(props, { root }) {
        const itemObj: any = inject('itemObj')
        const projectStore = useProjectStore()
        const { projectInfo } = storeToRefs(projectStore)
        itemObj.message_entity.entity_type = EntityType.poll
        itemObj.message_entity.duration = typeDurationOption[EntityType.poll].value

        const entityTypeInfo = reactive({
            value: EntityType.poll,
            oldValue: itemObj.message_entity.entity_type,
            option: sesstionPollItems,
            change: () => {
                const textPoll = [EntityType.poll, EntityType.poll_multi]
                const imagePoll = [EntityType.picture_poll, EntityType.picture_poll_multi]
                if (
                    (textPoll.includes(itemObj.message_entity.entity_type) && !textPoll.includes(entityTypeInfo.oldValue)) ||
                    (imagePoll.includes(itemObj.message_entity.entity_type) && !imagePoll.includes(entityTypeInfo.oldValue))
                ) {
                    itemObj.message_entity.options = []
                    itemObj.message_entity.settings = [
                        {
                            options: {
                                randomized: false,
                                other: false,
                                none: false
                            }
                        }
                    ]
                }
                entityTypeInfo.oldValue = itemObj.message_entity.entity_type
            }
        })

        watch(
            () => itemObj.message_entity.settings,
            (newValue, oldValue) => {
                const options = newValue[0]?.options
                if (options) {
                    const optionsCopy = _.cloneDeep(itemObj.message_entity.options)
                    itemObj.message_entity.options = itemObj.message_entity.options.filter((item: any) => !item.is_system)
                    if (options.other) {
                        const opt = optionsCopy.find((v: any) => v.is_system && v.option_type == 'other')
                        itemObj.message_entity.options.push(
                            opt
                                ? opt
                                : {
                                      is_system: true,
                                      text: root.$t('projectSurvey.optionType.other', projectInfo.value.detail_language),
                                      is_show: true,
                                      option_type: 'other'
                                  }
                        )
                    }
                    if (options.none) {
                        const opt = optionsCopy.find((v: any) => v.is_system && v.option_type == 'none')
                        itemObj.message_entity.options.push(
                            opt
                                ? opt
                                : {
                                      is_system: true,
                                      text: root.$t('projectSurvey.optionType.none', projectInfo.value.detail_language),
                                      is_show: true,
                                      option_type: 'none'
                                  }
                        )
                    }
                    itemObj.message_entity.options.forEach((option: any, index: number) => {
                        option.sequence = index
                    })
                }
            },
            {
                deep: true
            }
        )

        return {
            EntityType,
            itemObj,
            entityTypeInfo
        }
    }
})
